module.exports = __webpack_public_path__ + "img/GR124.c49f5b2b.png";